<template>
  <v-empty-state icon="mdi-alert-circle-outline" color="error">
    <template #headline>Error</template>
    <template #title> Ein Fehler ist aufgetreten! </template>
    <template #text>
      <v-alert v-for="(error, index) in parsedErrors" :key="index" type="error">
        {{ error }}
      </v-alert>
      <span>
        Bitte versuchen Sie es später wieder oder kontaktieren Sie uns unter
        <a href="mailto:s.latkovic@brelag.com">s.latkovic@brelag.com</a>.
      </span>
    </template>
    <template #actions>
      <v-btn @click="exitError">Zurück</v-btn>
    </template>
  </v-empty-state>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

type ErrorComponentProps = {
  errors?: string
}
const props = withDefaults(defineProps<ErrorComponentProps>(), {
  errors: '',
})

const router = useRouter()

const parsedErrors = computed(() => {
  if (props.errors !== '') return JSON.parse(props.errors)
  return []
})

const exitError = () => {
  router.replace({ name: 'overview' })
}
</script>

<style lang="scss" scoped></style>
